<div class="h-full">
  <div class=" bg-gradient-to-tr from-[#0E205E] to-[#1D43C4] absolute inset-0 "></div>
  <img src="/assets/images/patternHover.png"
       alt=""
       class="absolute inset-0 mix-blend-screen  w-full h-full object-fill">

  <div class="md:w-8/12 w-10/12  h-8/12 flex flex-col justify-center items-center mx-auto h-full relative">

    <div class="relative bg-primary-300/50 p-3 rounded-lg md:mt-0 mt-[40px]"
         *ngIf="carouselItems$ |async as carouselitems">
      <div class="bg-primary-300/50 rounded-lg  shadow-md -mt-[40px] -mr-[40px]">
        <div
          class="relative object-fill lg:w-[700px] md:w-[450px] w-[300px] md:h-[400px] h-[250px] rounded-t-lg perspective-[1000px]">
          <div
            *ngFor="let image of carouselImages(carouselitems); let i = index"
            class="absolute w-full h-full transition-all duration-1000 ease-in-out bg-cover bg-center rounded-xl"
            [ngClass]="{'rotate-y-0 z-20 opacity-100': activeCarousel === i,'-rotate-y-180 z-10 opacity-0': activeCarousel !== i}"
            [style.backgroundImage]="'url(' +fileUrl + image + ')'"
          >
          </div>
        </div>
        <div class=" text-white text-center lg:text-lg md:text-md text-sm px-3 py-5 rounded-b-lg gap-3 flex flex-col">
              <span>
                {{ carouselitems[activeCarousel]?.title }}
              </span>

          <div class="flex items-center justify-center gap-2">
            <ng-container *ngFor="let n of carouselitems; let i=index">
                  <span class="inline-block h-1.5 w-1.5 rounded-full transition"
                        [ngClass]="{'bg-yellow-400': activeCarousel === i, 'bg-yellow-400/40': activeCarousel !== i}"
                        (click)="showSlide(i)">
                  </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="relative bg-primary-300/50 p-3 rounded-lg w-full mt-2 mb-10 md:-mr-[54px] -mr-[20px]"
         *ngIf="contactCenters$|async as contacts">
      <div class="flex flex-wrap gap-3 text-lg justify-center">
        @for (x of contacts?.socialMedia; track x) {
          <a [href]="x?.url" target="_blank" [title]="x?.title" class="text-white text-decoration-none">
            <mat-icon [svgIcon]="getSocialMediaIcon(x?.platform)"></mat-icon>
          </a>
        }
      </div>
    </div>
  </div>
</div>
